import React from 'react';
import './spinner.scss';

const Spinner: React.FC = () => (
    <div className="spinner">
        {''}
    </div>
);

export default Spinner;
